var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAllowed),expression:"isAllowed"}],staticClass:"btn btn-primary btn--big",on:{"click":_vm.openModal}},[_vm._v(_vm._s(_vm.buttonName))])
}
var staticRenderFns = []

export { render, staticRenderFns }